import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import { Button, Card, Form, Input, notification } from "antd";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

function UpdateCorevalues() {
  const [form] = Form.useForm();

  // const [coreValuesdata, setcoreValuesData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  const UpdateHandler = async (values: any) => {
    try {
      let obj = {
        coreValuesCaption: values.coreValuesCaption,
        coreValuesDescription: values.coreValuesDescription,
      };

      setIsLoading(true);
      let api = API.UPDATE_CORE_VALUES + id;
      console.log("API URL:", api);
      const postRequest: any = await POST(api, obj);
      if (postRequest?.status) {
        notification.success({ message: "core values updated successfully!" });
        form.resetFields();
        fetchoneCorevalues();
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchoneCorevalues = async () => {
    try {
      setIsLoading(true);
      let api = API.GET_ONE_CORE_VALUES + id;
      console.log("API URL:", api);
      const response: any = await GET(api, {});
      // setcoreValuesData(response?.data);
      form.setFieldsValue(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchoneCorevalues();
  }, []);

  return (
    <div>
      <h1>Update Core values Page</h1>
      <Card>
        <Form form={form} onFinish={UpdateHandler} layout="vertical">
          <Form.Item
            name="coreValuesCaption"
            label="coreValuesCaption"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="coreValuesDescription"
            label="coreValuesDescription"
            rules={[
              { required: true, message: "coreValuesDescription is required" },
            ]}
          >
            <Input.TextArea />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Card>
    </div>
  );
}

export default UpdateCorevalues;
